export default "__VITE_ASSET__C3kCl$WJ__"